import {Component, Injector, OnInit} from '@angular/core';
import {Config} from '../../../common/config';
import {RouteUtil} from '../../../util/route.util';
import {DeviceService} from '../../../util/service/device.service';
import {DataResponse} from '../../../network/service/data.response';
import {RequestType} from '../../../enums/request.type';
import {BaseComponent} from '../../base.component';
import {routes} from '../../app.routes';

@Component({
  selector: 'app-client-dashboard',
  standalone: false,
  templateUrl: './client-dashboard.component.html',
  styleUrl: './client-dashboard.component.scss'
})
export class ClientDashboardComponent extends BaseComponent implements OnInit {
  isMobile?: boolean;
  branchUniqueIdentifier?: string;
  protected readonly Config = Config;
  protected readonly RouteUtil = RouteUtil;
  protected readonly routes = routes;

  constructor(injector: Injector, deviceService: DeviceService) {
    super(injector);
    this.isMobile = deviceService.isMobile();
    if (this.router.url.split('/')[1] !== RouteUtil.ACCOUNT_COMPONENT && ![RouteUtil.PROFILE_COMPONENT, RouteUtil.FAVORITE_COMPONENT, RouteUtil.ADDRESS_COMPONENT].includes(this.router.url.split('/')[2])) {
      this.branchUniqueIdentifier = this.router.url.split('/')[2].split('?')[0];
    }
  }

  override ngOnInit() {
    super.ngOnInit();
  }

  override loadOnline(): void {
    super.loadOnline();
    this.serviceApi.getBranches(undefined, undefined, undefined, RequestType.ONE, {
      Filter: {
        Values: [
          {
            Field: 'UniqueIdentifier',
            Type: 'EQ',
            Value: this.branchUniqueIdentifier
          }
        ]
      }
    }).subscribe((res: DataResponse<any>) => {
      if (res.success) {
        Config.branch = res.data;
      }
    });
  }

  isLandingPage(): boolean {
    const currentUrl = this.router.url;
    const landingPath = `/${RouteUtil.LANDING_COMPONENT}/${Config.branch.UniqueIdentifier}`;
    const rootPath = `/${Config.branch.UniqueIdentifier}`;
    return currentUrl === landingPath || currentUrl === rootPath;
  }
}
